// Der Kopieren-Knopf neben dem frisch angelegten API-Schlüssel auf /konto.
//
// Kein React-Komponent, aus demselben Grund wie der Zeichenzähler: die
// Kontoseite ist server-gerendert. Der Knopf trägt `data-copy-target` mit der
// ID des Elements, dessen Text in die Zwischenablage soll, und sagt danach
// kurz „Kopiert“ (aus `data-copied-text`), bevor er wieder zu seinem alten
// Text zurückfindet. Ohne Clipboard-API (http ohne localhost, alte Browser)
// bleibt der Text markierbar -- `user-select: all` am Token -- und der Knopf
// sagt ehrlich, dass er es nicht konnte.

export const COPIED_RESET_MS = 2000

export function copiedLabel(button: HTMLElement): string {
  return button.dataset.copiedText ?? 'Kopiert'
}

export type Clipboard = { writeText(text: string): Promise<void> }

export async function copyFrom(
  button: HTMLElement,
  root: ParentNode = document,
  clipboard: Clipboard | undefined = navigator.clipboard,
): Promise<boolean> {
  const target = root.querySelector<HTMLElement>(`#${button.dataset.copyTarget ?? ''}`)
  if (!target || !clipboard) return false

  try {
    await clipboard.writeText(target.textContent?.trim() ?? '')
    return true
  } catch {
    return false
  }
}

export function startCopyButtons(root: ParentNode = document): void {
  const buttons = root.querySelectorAll<HTMLButtonElement>('[data-copy-target]')

  buttons.forEach((button) => {
    const original = button.textContent ?? ''

    button.addEventListener('click', () => {
      void copyFrom(button, root).then((copied) => {
        button.textContent = copied ? copiedLabel(button) : 'Kopieren nicht möglich'
        window.setTimeout(() => {
          button.textContent = original
        }, COPIED_RESET_MS)
      })
    })
  })
}
